import cookies from 'react-cookies';
import { IncomingMessage } from 'http';

import { ABNTest } from '@r1-frontend/api-domru/api-content/v1/geography/get-city-info/dto/ABNTest';

import { ABN_DEFAULT_VARIANT_COOKIE, ABN_VARIANTS_COOKIE } from '~/src/constants';
import { getCookie } from '~/src/helpers/cookie';

export const getCid = (abnTestValue: string) => {
    const values = abnTestValue.split('.') || [];

    const [, value = 0] = values;

    return +value;
};

export const getVariantByValue = (variants: ABNTest['variants'], randomValue: number) => {
    for (const variant of variants) {
        randomValue -= Number(variant.traffic);

        if (randomValue <= 0) {
            return variant;
        }
    }

    return null;
};

/**
 * Возвращает дефолтный вариант из куки 'abn_default_variant', если установлена.
 * Кука 'abn_default_variant' должна иметь формат типа: { 'showing_menu': 'menu_new' }
 */
export const getDefaultVariantFrom = (testName: string, variants?: string): string | undefined => {
    const defaultVariantsCookie = variants ? JSON.parse(variants) : cookies.load(ABN_DEFAULT_VARIANT_COOKIE);
    return defaultVariantsCookie
        ? defaultVariantsCookie[testName]
        : undefined;
};

export const getABNVariants = (abnTests: ABNTest[], abnTestValue: string): string => {
    const valuesStr = abnTests?.reduce((acc: string[], currTest) => {
        if (Array.isArray(currTest.variants) && currTest.variants.length) {
            const selectVariant = getVariantByValue(currTest.variants, getCid(abnTestValue));
            acc.push(`${currTest.name}:${selectVariant?.label}`);
        } else {
            acc.push(`${currTest.name}:on`);
        }

        return acc;
    }, []);

    return valuesStr.join(',');
};

export const getABNVariantFrom = (testName: string, abnTests: string, defaultVariants?: string) => {
    /* Проверка есть ли дефолтный вариант */
    const defaultVariant = getDefaultVariantFrom(testName, defaultVariants);
    if (defaultVariant) {
        return defaultVariant;
    }

    return abnTests
        .split(',')
        .map((test: string) => {
            const [currentTestName, variant] = test.split(':');

            return { testName: currentTestName, variant };
        })
        .find((test: { testName: string, variant: string }) => test.testName === testName)
        ?.variant;
};

/* ABN Тест без вариантов - вернет 'on' во включенном состоянии
 ABN Тест с вариантами - настроенный вариант
 */
export const getABNVariant = (testName: string): string | undefined => {
    const abnTests = cookies.load(ABN_VARIANTS_COOKIE);
    if (abnTests) {
        return getABNVariantFrom(testName, abnTests);
    }
};

export const getABNVariantOnSSr = (testName: string, req?: IncomingMessage): string | undefined => {
    const abnTests = req ? getCookie(ABN_VARIANTS_COOKIE, req) : cookies.load(ABN_VARIANTS_COOKIE);
    if (abnTests) {
        return getABNVariantFrom(testName, abnTests);
    }
};
